<template>
  <div class="scene-pos-edit-container">
    <div class="common-tree-box">
      <el-tree
      class="dialog-tree-small-primary"
        ref="scenePosEditDataTree"
        :data="sceneData"
        :props="defaultProps"
        node-key="nodeId"
        highlight-current
        show-checkbox
        :expand-on-click-node="false"
        @node-click="handleNodeClick"
        @check="handleNodeCheck"
      >
        <template slot-scope="{ data }">
          <div :class="getTreeNodeClassName(data)">
            <div class="nodel-label-box">
              <div class="icon-box" v-if="data.nodeType !== 2">
                <icon-svg :icon-class="getIcon(data)" />
              </div>
              <div class="label-box text-overflow" :title="data.nodeName">
                {{ data.nodeName }}
              </div>
            </div>
            <div class="custom-button-box">
              <el-button
                type="text"
                size="small"
                title="显示"
                :disabled="isBtnDisabled(data)"
                @click="(e) => toggleView(data, e)"
              >
                <icon-svg
                  v-if="!isHidden(data)"
                  icon-class="ic-xianshi1"
                  class="icon"
                />
                <icon-svg v-else icon-class="ic-a-yincang1" class="icon" />
              </el-button>
            </div>
          </div>
        </template>
      </el-tree>
    </div>
  </div>
</template>

<script>
import {
  getDataSetResService,
  saveSceneOffset,
  initScenePosService,
  editExtrudeService,
} from "@/service/interface";

const elemDataSetType = [17, 18, 19];

// 允许控制点配准的数据类型
const isControlMatchEnableTypes = [0];

export default {
  data() {
    return {
      defaultProps: {
        children: "subNodes",
        label: "nodeName",
      },
      disabledDataSetIds: [],
      hiddenNodes: [],
    };
  },
  props: {
    sceneInfo: Object,
    sceneData: Array,
    posEditInfo: Object,
    updateSceneInfo: Function,
    updateSceneTree: Function,
    exitPosEditMode: Function,
    showDataSets: Function,
    hideDataSets: Function,
    focusDataSets: Function,
    focusEntities: Function,
  },
  mounted() {
    this.$eventManage.on("selElement", this.handleSelElement);
    this.$eventManage.on("selShpElement", this.handleSelShpElement);
    this.$eventManage.on("resetPosition", this.resetPosition);
    this.$eventManage.on("savePosition", this.savePosition);
    this.$eventManage.on("exitPositionEdit", this.exitEditPosition);
  },
  beforeDestroy() {
    this.$eventManage.off("selElement", this.handleSelElement);
    this.$eventManage.off("selShpElement", this.handleSelShpElement);
    this.$eventManage.off("resetPosition", this.resetPosition);
    this.$eventManage.off("savePosition", this.savePosition);
    this.$eventManage.off("exitPositionEdit", this.exitEditPosition);
  },
  methods: {
    initEdit() {
      this.formatSceneData(this.sceneData);
      this.setCheckedKeys();
      this.setExpandNodes();

      this.setDataSetsEditDisable();
      this.setSelElemsBlendAttr();

      const BlackHole3D = window.BlackHole3D;
      BlackHole3D.Edit.startEdit(1);
      let { dataSetType, selectedDataSets } = this.posEditInfo;
      let dataSets = [];
      selectedDataSets.forEach((item) => {
        if (elemDataSetType.includes(item.dataSetType)) {
          let dataSetId = item.srcDataSetId.replaceAll("-", "");
          let find = dataSets.find((el) => el.dataSetId === dataSetId);
          if (find) {
            find.elemIdList.push(item.elemId);
            find.elemIds.push(item.elemId);
          } else {
            let obj = {
              dataSetId,
              dataSetType: item.dataSetType,
              elemIdList: [item.elemId],
              // 增加elemIds字段，方便复用构件定位功能
              elemIds: [item.elemId],
            };
            dataSets.push(obj);
          }
        } else {
          let dataSetId = item.dataSetId.replaceAll("-", "");
          let obj = {
            dataSetId,
            dataSetType: item.dataSetType,
            elemIdList: [],
            elemIds: [],
          };
          dataSets.push(obj);
        }
      });

      if (elemDataSetType.includes(dataSetType)) {
        this.focusEntities(dataSets);
      } else {
        this.focusDataSets(dataSets);
      }

      if (isControlMatchEnableTypes.includes(dataSetType)) {
        BlackHole3D.Graphics.setTabItemVisable("ControlPosMatchPage", true);
      } else {
        BlackHole3D.Graphics.setTabItemVisable("ControlPosMatchPage", false);
      }

      if (!elemDataSetType.includes(dataSetType)) {
        BlackHole3D.BIM.setSelMode(0);
      } else {
        BlackHole3D.BIM.setSelMode(1);
      }

      dataSets.forEach((item) => {
        if (!elemDataSetType.includes(item.dataSetType)) {
          BlackHole3D.BIM.addToSelDataSet(item.dataSetId);
        } else {
          BlackHole3D.BIM.addToSelElems(item.dataSetId, item.elemIdList);
        }
      });
    },
    handleNodeClick(nodeData) {
      if (this.isEntityNode(nodeData)) {
        this.focusToEntityList(nodeData);
      } else {
        this.focusToDataSetList(nodeData);
      }
    },
    handleNodeCheck(nodeData) {
      let domRef = this.$refs.scenePosEditDataTree;
      let nodeObject = domRef.getNode(nodeData);

      let checkedNodes = domRef.getCheckedNodes();
      let allDataSets = checkedNodes.filter((el) => el.nodeType === 2);

      let isDistanceCheckPass = this.isDistanceCheckPass(allDataSets);
      if (!isDistanceCheckPass) {
        // prettier-ignore
        let warningMsg ="所选数据集与当前正在编辑的数据集之间距离太远，不可同时编辑，请重新选择";
        this.$message.warning(warningMsg);

        this.handleDistanceCheckUnPass(nodeData);
        return;
      }

      const BlackHole3D = window.BlackHole3D;
      let dataSets = this.getAllFormatedDataSets(nodeData);
      if (nodeObject.checked) {
        dataSets.forEach((item) => {
          if (!elemDataSetType.includes(item.dataSetType)) {
            BlackHole3D.BIM.addToSelDataSet(item.dataSetId);
          } else {
            BlackHole3D.BIM.addToSelElems(item.dataSetId, item.elemIdList);
          }
        });
      } else {
        let dataSetType = this.posEditInfo.dataSetType;
        if (!elemDataSetType.includes(dataSetType)) {
          let dataSetIds = dataSets.map((el) => el.dataSetId);
          BlackHole3D.BIM.delFromSelDateSets(dataSetIds);
        } else {
          dataSets.forEach((item) => {
            BlackHole3D.BIM.delFromSelElems(item.dataSetId, item.elemIdList);
          });
        }
      }
    },
    handleDistanceCheckUnPass(nodeData) {
      let domRef = this.$refs.scenePosEditDataTree;

      let childNodes = this.findAllChildNodes([nodeData]);
      let childNodeKeys = childNodes.map((item) => item.nodeId);
      let nodeObject = domRef.getNode(nodeData);
      let parentNodes = this.findAllParentNodes(nodeObject.parent);
      let parentNodeKeys = parentNodes.map((item) => item.nodeId);
      let checkedNodes = domRef.getCheckedNodes();
      let checkedKeys = checkedNodes.map((el) => el.nodeId);

      parentNodeKeys.forEach((item) => {
        let findIndex = checkedKeys.findIndex((el) => el === item);
        if (findIndex !== -1) {
          checkedKeys.splice(findIndex, 1);
        }
      });

      childNodeKeys.forEach((item) => {
        let findIndex = checkedKeys.findIndex((el) => el === item);
        if (findIndex !== -1) {
          checkedKeys.splice(findIndex, 1);
        }
      });

      this.$nextTick(() => {
        domRef.setCheckedKeys(checkedKeys);
      });
    },
    toggleView(nodeData, e) {
      e && e.stopPropagation();

      let allDataSets = this.findAllNodeByLevel([nodeData], 2);
      let dataSets = allDataSets.map((item) => {
        let dataSetId = "";
        if (elemDataSetType.includes(item.srcDataSetType)) {
          dataSetId = item.srcDataSetId.replaceAll("-", "");
        } else {
          dataSetId = item.dataSetId.replaceAll("-", "");
        }
        let obj = {
          dataSetId,
          dataSetType: item.srcDataSetType,
          elemId: item.elemId,
        };
        return obj;
      });

      if (this.isHidden(nodeData)) {
        allDataSets.forEach((item) => {
          let findIndex = this.hiddenNodes.findIndex(
            (el) => el === item.nodeId
          );
          if (findIndex !== -1) {
            this.hiddenNodes.splice(findIndex, 1);
          }
        });

        this.showDataSets(dataSets);
      } else {
        allDataSets.forEach((item) => {
          let find = this.hiddenNodes.find((el) => el === item.nodeId);
          if (!find) {
            this.hiddenNodes.push(item.nodeId);
          }
        });
        this.hideDataSets(dataSets);
      }
    },
    handleSelElement(eventInfo) {
      // 防止创建和编辑矢量辅助面时触发误操作
      let state = window.BlackHole3D.Edit.getEditState();
      if (state === 0) return;

      let elemInfo = eventInfo.elemInfo;
      if (!elemInfo.dataSetId) return;
      // 如果选择了不可编辑的数据集或构件，需要将其从选择集中移除
      this.delDataFromSel(elemInfo);
      this.addNodeToCheckedNodes(elemInfo);
    },
    handleSelShpElement(eventInfo) {
      // 防止创建和编辑矢量辅助面时触发误操作
      let state = window.BlackHole3D.Edit.getEditState();
      if (state === 0) return;

      let shpElemInfo = eventInfo.shpElemInfo;
      if (!shpElemInfo.dataSetId) return;
      // 如果选择了不可编辑的数据集或构件，需要将其从选择集中移除
      this.delDataFromSel(shpElemInfo);
      this.addNodeToCheckedNodes(shpElemInfo);
    },
    initPosition() {
      this.initPositionCheck().then(() => {
        // prettier-ignore
        let warningMsg = "该操作将清除场景内的所有位置变换信息，且不可恢复，确定要继续吗？";

        this.$confirm(warningMsg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let sceneId = this.$route.query.sceneId;
            initScenePosService(sceneId).then((response) => {
              if (response.isSuccess) {
                this.updateSceneInfo().then(() => {
                  this.updateSceneTree().then(() => {
                    this.initDataSetPos().then(() => {
                      this.saveExtrude().then(() => {
                        this.initEntityElemsPos();

                        this.$message.success("初始化位置成功");
                      });
                    });
                  });
                });
              } else {
                this.$message.error(response.errMsg);
              }
            });
          })
          .catch(() => {
            this.$message.info("取消初始化位置");
          });
      });
    },
    initPositionCheck() {
      return new Promise((resolve) => {
        const BlackHole3D = window.BlackHole3D;

        let editMode = BlackHole3D.Entity.getEditMode();
        if (editMode) {
          this.$confirm("当前正在添加构件，是否退出", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$eventManage.fire("exitEntityEdit", {});
              this.$message.info("退出构件添加");
            })
            .catch(() => {
              this.$message.info("取消退出");
            });
          return;
        } else {
          resolve();
        }
      });
    },
    resetPosition() {
      return new Promise((resolve) => {
        let allDataSets = this.findAllNodeByLevel(this.sceneData, 2);
        allDataSets = allDataSets.filter((el) => !el.disabled);

        let dataSetType = this.posEditInfo.dataSetType;
        if (elemDataSetType.includes(dataSetType)) {
          this.resetEntityElemsPos(allDataSets);
        } else {
          this.resetDataSetsPos(allDataSets);
        }

        this.resetSel();
        resolve();
      });
    },
    resetSel() {
      const BlackHole3D = window.BlackHole3D;

      let selMode = BlackHole3D.BIM.getSelMode();
      let dataSetIds = BlackHole3D.BIM.getSelDataSetIDs();
      let selElemIds = BlackHole3D.BIM.getSelElemIDs();

      BlackHole3D.BIM.delAllSelDateSets();
      BlackHole3D.BIM.delAllSelElems();

      BlackHole3D.BIM.setSelMode(selMode);

      if (selMode === 0) {
        dataSetIds.forEach((item) => {
          BlackHole3D.BIM.addToSelDataSet(item);
        });
      } else {
        selElemIds.forEach((item) => {
          BlackHole3D.BIM.addToSelElems(item.dataSetId, item.elemIdList);
        });
      }
    },
    exitEditPosition() {
      this.$confirm("退出后，您的所有操作不被保留，确定要退出吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.resetPosition().then(() => {
            this.exitPosEditMode();
            window.BlackHole3D.Edit.endEdit();
          });
        })
        .catch(() => {
          this.$message.info("取消退出");
        });
    },
    // 保存开挖数据，防止数据集进行移动配准后，开挖区域与原来不一致
    saveExtrude() {
      return new Promise((resolve) => {
        let leafNodes = this.findAllNodeByLevel(this.sceneData, 2);
        let extrudeDatas = leafNodes.filter((el) => el.dataSetType === 24);
        let changedExtrudeData = this.getChangedExtudeData(extrudeDatas);
        let promiseArray = [];
        changedExtrudeData.forEach((item) => {
          let promise = this.saveExtrudeRequest(item);
          promiseArray.push(promise);
        });
        Promise.all(promiseArray).then((response) => {
          if (response.length === promiseArray.length) {
            resolve();
          }
        });
      });
    },
    getChangedExtudeData(extrudeDatas) {
      const Extrude = window.BlackHole3D.Extrude;
      let changedExtrudeData = [];
      extrudeDatas.forEach((item) => {
        let extrudeInfo = item.excavateInfo;
        let isChanged = this.isExtrudeRegChange(extrudeInfo);
        if (isChanged) {
          let extrudeID = extrudeInfo.id;
          let extrudeData = Extrude.getData([extrudeID]);
          let extrudeDataInfo = extrudeData[0];
          let params = {
            nodeId: item.nodeId,
            digType: extrudeInfo.digType,
            // prettier-ignore
            textureFileDataId: extrudeInfo.textureFileDataId,
            geojson: JSON.stringify(extrudeDataInfo),
            treeNodeIds: extrudeInfo.treeNodeIds,
          };
          changedExtrudeData.push(params);
        }
      });
      return changedExtrudeData;
    },
    isExtrudeRegChange(extrudeInfo) {
      let geoJson = JSON.parse(extrudeInfo.geoJson);
      let originRgnList = geoJson.rgnList;
      let originPointList = originRgnList[0];

      const Extrude = window.BlackHole3D.Extrude;
      let extrudeID = extrudeInfo.id;
      let extrudeData = Extrude.getData([extrudeID]);
      let newExtrudeInfo = extrudeData[0];
      let newRgnList = newExtrudeInfo.rgnList;
      let newPointList = newRgnList[0];

      let isChange = this.isArrayChanged(originPointList, newPointList);
      return isChange;
    },
    saveExtrudeRequest(params) {
      return new Promise((resolve) => {
        editExtrudeService(params).then((response) => {
          if (response.isSuccess) {
            resolve(response);
          } else {
            this.$message.error(response.errMsg);
          }
        });
      });
    },
    savePosition() {
      return new Promise((resolve) => {
        this.saveExtrude().then(() => {
          this.getPosChangedDataSets().then((changedDatasets) => {
            let changedElems = this.getPosChangedElems();
            if (!changedDatasets.length && !changedElems.length) {
              this.$message.warning("尚未对位置做出更改！！！");
              resolve();
              return;
            }
            let sceneId = this.$route.query.sceneId;
            let params = { sceneId };
            if (changedDatasets.length) {
              params.dataSets = changedDatasets;
            }
            if (changedElems.length) {
              params.components = changedElems;
            }
            saveSceneOffset(params).then((response) => {
              if (response.isSuccess) {
                this.updateSceneInfo().then(() => {
                  this.updateSceneTree();

                  window.BlackHole3D.Edit.endEdit();
                  window.BlackHole3D.BIM.setSelMode(1);

                  this.exitPosEditMode();

                  this.$message.success("位置更新成功");
                  resolve();
                });
              } else {
                this.$message.error(response.errMsg);
              }
            });
          });
        });
      });
    },
    isArrayChanged(originPoints, newPoints) {
      if (originPoints.length !== newPoints.length) return true;

      return originPoints.some((point1, index) => {
        const point2 = newPoints[index];
        // prettier-ignore
        return  point1[0] !== point2[0] || point1[1] !== point2[1] || point1[2] !== point2[2];
      });
    },
    resetDataSetsPos(dataSets) {
      const BlackHole3D = window.BlackHole3D;

      // prettier-ignore
      let dataSetPos = JSON.parse(JSON.stringify(this.sceneInfo.dataSetPosition));
      dataSets.forEach((item) => {
        let find = dataSetPos.find((el) => el.dataSetId === item.dataSetId);
        let locInfo = new BlackHole3D.RELocInfo();
        if (find) {
          let scale = find.scale.split(" ");
          let rotate = find.rotate.split(" ");
          let offset = find.translation.split(" ");
          scale = scale.map((el) => Number(el));
          rotate = rotate.map((el) => Number(el));
          offset = offset.map((el) => Number(el));

          locInfo.scale = scale;
          locInfo.rotate = rotate;
          locInfo.offset = offset;
        } else {
          locInfo.scale = [1, 1, 1];
          locInfo.rotate = [0, 0, 0, 1];
          locInfo.offset = [0, 0, 0];
        }

        let dataSetId = item.dataSetId;
        dataSetId = dataSetId.replaceAll("-", "");
        BlackHole3D.Coordinate.setDataSetTransform(dataSetId, locInfo);
      });
    },
    resetEntityElemsPos(dataSets) {
      const BlackHole3D = window.BlackHole3D;
      dataSets.forEach((item) => {
        let location = item.componentInfo.location;
        let locInfo = new BlackHole3D.RELocInfo();
        locInfo.scale = JSON.parse(location.scale);
        locInfo.rotate = JSON.parse(location.rotate);
        locInfo.offset = JSON.parse(location.translation);
        let dataSetId = item.srcDataSetId;
        dataSetId = dataSetId.replaceAll("-", "");
        BlackHole3D.Entity.setTransInfo(dataSetId, item.elemId, locInfo);
      });
    },
    initDataSetPos() {
      return new Promise((resolve) => {
        let dataSets = this.findAllNodeByLevel(this.sceneData, 2);
        dataSets = dataSets.filter(
          // prettier-ignore
          (el) => el.viewStatus !== 2 && !elemDataSetType.includes(el.dataSetType)
        );
        if (dataSets.length) {
          this.queryDataSetResource().then((datasetsPosition) => {
            datasetsPosition.forEach((item) => {
              let scale = item.scale.split(" ");
              let rotate = item.rotate.split(" ");
              let offset = item.translation.split(" ");
              scale = scale.map((el) => Number(el));
              rotate = rotate.map((el) => Number(el));
              offset = offset.map((el) => Number(el));

              let dataSetId = item.resId;
              const BlackHole3D = window.BlackHole3D;
              let locInfo = new BlackHole3D.RELocInfo();
              locInfo.scale = scale;
              locInfo.rotate = rotate;
              locInfo.offset = offset;
              BlackHole3D.Coordinate.setDataSetTransform(dataSetId, locInfo);
            });

            resolve();
          });
        } else {
          resolve();
        }
      });
    },
    initEntityElemsPos() {
      let dataSets = this.findAllNodeByLevel(this.sceneData, 2);
      dataSets = dataSets.filter(
        // prettier-ignore
        (el) => el.viewStatus !== 2 && elemDataSetType.includes(el.dataSetType)
      );

      const BlackHole3D = window.BlackHole3D;
      dataSets.forEach((item) => {
        let location = item.componentInfo.location;
        let locInfo = new BlackHole3D.RELocInfo();
        locInfo.scale = JSON.parse(location.scale);
        locInfo.rotate = JSON.parse(location.rotate);
        locInfo.offset = JSON.parse(location.translation);
        let dataSetId = item.srcDataSetId;
        dataSetId = dataSetId.replaceAll("-", "");
        BlackHole3D.Entity.setTransInfo(dataSetId, item.elemId, locInfo);
      });
    },
    queryDataSetResource() {
      return new Promise((resolve) => {
        let dataSets = this.findAllNodeByLevel(this.sceneData, 2);
        dataSets = dataSets.filter(
          // prettier-ignore
          (el) => el.viewStatus !== 2 && !elemDataSetType.includes(el.dataSetType)
        );

        let dataSetIds = dataSets.map((el) => el.dataSetId);
        let params = { dataSetIds };
        getDataSetResService(params).then((response) => {
          if (response.isSuccess) {
            let data = response.data;
            resolve(data);
          } else {
            this.$message.error(response.errMsg);
          }
        });
      });
    },
    // 从选择集中移除数据集或构件
    delDataFromSel(elemInfo) {
      const BlackHole3D = window.BlackHole3D;

      let find = this.disabledDataSetIds.find(
        (el) => el === elemInfo.dataSetId
      );
      if (find) {
        if (this.isEntityElem(elemInfo)) {
          BlackHole3D.BIM.delFromSelElems(find, [elemInfo.elemId]);
        } else {
          BlackHole3D.BIM.delFromSelDateSets([find]);
        }
      }
    },
    addNodeToCheckedNodes(elemInfo) {
      const BlackHole3D = window.BlackHole3D;

      let nodeIds = [];
      let allDataSets = this.findAllNodeByLevel(this.sceneData, 2);
      allDataSets = allDataSets.filter((el) => !el.disabled);
      if (this.isEntityElem(elemInfo)) {
        let selElemIds = BlackHole3D.BIM.getSelElemIDs();
        allDataSets.find((item) => {
          let dataSetId = item.srcDataSetId;
          dataSetId = dataSetId.replaceAll("-", "");
          let find = selElemIds.find((el) => el.dataSetId === dataSetId);
          if (find) {
            let elemIdList = find.elemIdList;
            if (elemIdList.includes(item.elemId)) {
              nodeIds.push(item.nodeId);
            }
          }
        });
      } else {
        let selDataSetIds = BlackHole3D.BIM.getSelDataSetIDs();
        allDataSets = allDataSets.filter((item) => {
          let dataSetId = item.dataSetId;
          dataSetId = dataSetId.replaceAll("-", "");

          if (selDataSetIds.includes(dataSetId)) {
            return true;
          } else {
            return false;
          }
        });

        let isDistanceCheckPass = this.isDistanceCheckPass(allDataSets);
        if (!isDistanceCheckPass) {
          // prettier-ignore
          let warningMsg ="所选数据集与当前正在编辑的数据集之间距离太远，不可同时编辑，请重新拾取";
          this.$message.warning(warningMsg);

          let findIndex = selDataSetIds.findIndex(
            (el) => el === elemInfo.dataSetId
          );
          if (findIndex !== -1) {
            selDataSetIds.splice(findIndex, 1);
            BlackHole3D.BIM.delFromSelDateSets([elemInfo.dataSetId]);
          }
        }

        allDataSets.find((item) => {
          let dataSetId = item.dataSetId;
          dataSetId = dataSetId.replaceAll("-", "");

          if (selDataSetIds.includes(dataSetId)) {
            nodeIds.push(item.nodeId);
          }
        });
      }

      let domRef = this.$refs.scenePosEditDataTree;
      domRef.setCheckedKeys(nodeIds);
    },
    setDataSetsEditDisable() {
      let dataSetType = this.posEditInfo.dataSetType;
      let allDataSets = this.findAllNodeByLevel(this.sceneData, 2);
      let disabledDataSets = allDataSets.filter(
        (el) => el.dataSetType !== dataSetType
      );
      let disabledDataSetIds = disabledDataSets.map((item) => {
        let dataSetId = "";
        if (elemDataSetType.includes(item.dataSetType)) {
          dataSetId = item.srcDataSetId.replaceAll("-", "");
        } else {
          dataSetId = item.dataSetId.replaceAll("-", "");
        }
        return dataSetId;
      });
      this.disabledDataSetIds = disabledDataSetIds;

      if (disabledDataSetIds.length) {
        window.BlackHole3D.Edit.setDataSetEditEnable(disabledDataSetIds, false);
      }
    },
    setSelElemsBlendAttr() {
      const BlackHole3D = window.BlackHole3D;
      let blendAttr = BlackHole3D.BIM.getSelElemsBlendAttr();
      blendAttr.elemClr = new BlackHole3D.REColor(255, 0, 0, 200);
      blendAttr.clrWeight = 128;
      blendAttr.alphaWeight = 200;
      BlackHole3D.BIM.setSelElemsBlendAttr(blendAttr);
    },
    isHidden(nodeData) {
      let isHidden = false;
      let nodeType = nodeData.nodeType;
      if (nodeType === 2) {
        if (this.hiddenNodes.includes(nodeData.nodeId)) {
          isHidden = true;
        } else {
          isHidden = false;
        }
      } else {
        let allDataSets = this.findAllNodeByLevel([nodeData], 2);
        if (!allDataSets.length) {
          isHidden = true;
        } else {
          isHidden = allDataSets.every((el) =>
            this.hiddenNodes.includes(el.nodeId)
          );
        }
      }
      return isHidden;
    },
    isEntityNode(nodeData) {
      let allData = this.findAllNodeByLevel([nodeData], 2);
      let isEntity = allData.every((el) =>
        elemDataSetType.includes(el.srcDataSetType)
      );
      return isEntity;
    },
    isDistanceCheckPass(dataSets) {
      let dataSetType = this.posEditInfo.dataSetType;
      // 因引擎暂不支持获取不同类型单构件的包围盒大小，因此单构件编辑暂时跳过距离检验
      if (elemDataSetType.includes(dataSetType)) {
        return true;
      }

      const maxDistance = 1000000; // 距离阈值 1000公里
      let totalBBoxInfo = this.getTotalBBoxInfo(dataSets);
      let isLengthPass = totalBBoxInfo[0] < maxDistance ? true : false;
      let isWidthPass = totalBBoxInfo[1] < maxDistance ? true : false;
      let isHeightPass = totalBBoxInfo[2] < maxDistance ? true : false;

      if (isLengthPass && isWidthPass && isHeightPass) {
        return true;
      } else {
        return false;
      }
    },
    getTotalBBoxInfo(dataSets) {
      let xValue = [];
      let yValue = [];
      let zValue = [];

      const BlackHole3D = window.BlackHole3D;
      dataSets.forEach((item) => {
        let bbox;
        let dataSetId = item.dataSetId.replaceAll("-", "");
        if (item.dataSetType === 0) {
          bbox = BlackHole3D.BIM.getTotalBV(dataSetId);
        } else {
          bbox = BlackHole3D.Grid.getDataSetBV(dataSetId);
        }
        xValue.push(bbox[0], bbox[1]);
        yValue.push(bbox[2], bbox[3]);
        zValue.push(bbox[4], bbox[5]);
      });

      let bboxLength = Math.max(...xValue) - Math.min(...xValue);
      let bboxWidth = Math.max(...yValue) - Math.min(...yValue);
      let bboxHeight = Math.max(...zValue) - Math.min(...zValue);

      return [bboxLength, bboxWidth, bboxHeight];
    },
    getPosChangedDataSets() {
      return new Promise((resolve) => {
        let allDataSets = this.findAllNodeByLevel(this.sceneData, 2);
        allDataSets = allDataSets.filter(
          (el) => !elemDataSetType.includes(el.dataSetType)
        );

        const Coordinate = window.BlackHole3D.Coordinate;
        // prettier-ignore
        let dataSetPos =  JSON.parse(JSON.stringify(this.sceneInfo.dataSetPosition));
        let originTransInfo = this.formatTransInfo(dataSetPos);
        let allTransInfo = [];
        allDataSets.forEach((item) => {
          let dataSetId = item.dataSetId.replaceAll("-", "");
          let transformInfo = Coordinate.getDataSetTransform(dataSetId);
          let obj = {
            dataSetId: item.dataSetId,
            rotate: transformInfo.rotate,
            scale: transformInfo.scale,
            translation: transformInfo.offset,
          };
          allTransInfo.push(obj);
        });

        let changedDataSets = this.getChangedDataSets(
          allTransInfo,
          originTransInfo
        );
        resolve(changedDataSets);
      });
    },
    getPosChangedElems() {
      let allEntityElems = this.findAllNodeByLevel(this.sceneData, 2);
      allEntityElems = allEntityElems.filter((el) =>
        elemDataSetType.includes(el.dataSetType)
      );

      let changedElems = [];
      const Entity = window.BlackHole3D.Entity;
      allEntityElems.forEach((item) => {
        let dataSetId = item.srcDataSetId;
        dataSetId = dataSetId.replaceAll("-", "");

        let componentInfo = item.componentInfo;
        let location = componentInfo.location;
        let currPosition = Entity.getTransInfo(dataSetId, [item.elemId]);
        currPosition = currPosition[0];

        let isChanged = this.isElemPosChanged(location, currPosition);
        if (isChanged) {
          let obj = {
            id: componentInfo.id,
            dataSetCrs: location.DataSetCRS,
            scale: JSON.stringify(currPosition.scale),
            rotate: JSON.stringify(currPosition.rotate),
            translation: JSON.stringify(currPosition.offset),
          };
          changedElems.push(obj);
        }
      });
      return changedElems;
    },
    getChangedDataSets(allTransInfo, originTransInfo) {
      let changedDatasets = [];
      allTransInfo.forEach((item) => {
        let find = originTransInfo.find(
          (el) => el.dataSetId === item.dataSetId
        );
        if (find) {
          let roteteChanged = this.isTransInfoChanged(find.rotate, item.rotate);
          let scaleChanged = this.isTransInfoChanged(find.scale, item.scale);
          let translationChanged = this.isTransInfoChanged(
            find.translation,
            item.translation
          );
          if (roteteChanged || scaleChanged || translationChanged) {
            changedDatasets.push(item);
          }
        } else {
          changedDatasets.push(item);
        }
      });
      changedDatasets.forEach((item) => {
        item["scale"] = item.scale.join(" ");
        item["rotate"] = item.rotate.join(" ");
        item["translation"] = item.translation.join(" ");
      });
      return changedDatasets;
    },
    isElemPosChanged(originPosition, currPosition) {
      let originOffset = JSON.parse(originPosition.translation);
      let currOffset = currPosition.offset;
      let originRotate = JSON.parse(originPosition.rotate);
      let currRotate = currPosition.rotate;
      let originScale = JSON.parse(originPosition.scale);
      let currScale = currPosition.scale;

      let offsetChanged = this.isTransInfoChanged(originOffset, currOffset);
      let roteteChanged = this.isTransInfoChanged(originRotate, currRotate);
      let scaleChanged = this.isTransInfoChanged(originScale, currScale);

      if (offsetChanged || roteteChanged || scaleChanged) {
        return true;
      } else {
        return false;
      }
    },
    isTransInfoChanged(originTransInfo, currTransInfo) {
      let changed = false;
      changed = originTransInfo.some((originValue, index) => {
        return originValue - currTransInfo[index] !== 0;
      });
      return changed;
    },
    focusToDataSetList(nodeData) {
      let allDataSets = this.findAllNodeByLevel([nodeData], 2);
      allDataSets = allDataSets.filter((el) => el.viewStatus !== 2);

      if (!allDataSets.length) {
        if (nodeData.nodeType !== 2) {
          this.$message.warning("当前节点下不存在有效的数据集，无法定位");
        } else {
          this.$message.warning("当前数据集已失效，无法定位");
        }
        return;
      }

      let dataSets = allDataSets.map((item) => {
        let dataSetId = item.dataSetId.replaceAll("-", "");
        let dataSetType = item.dataSetType;
        return { dataSetId, dataSetType };
      });
      this.focusDataSets(dataSets);
    },
    focusToEntityList(nodeData) {
      let allDataSets = this.findAllNodeByLevel([nodeData], 2);
      let entities = [];
      allDataSets.forEach((item) => {
        let find = entities.find((el) => el.dataSetId === item.srcDataSetId);
        if (find) {
          find.elemIds.push(item.elemId);
        } else {
          let obj = {
            dataSetId: item.srcDataSetId,
            elemIds: [item.elemId],
          };
          entities.push(obj);
        }
      });

      entities.forEach((item) => {
        item.dataSetId = item.dataSetId.replaceAll("-", "");
      });

      this.focusEntities(entities);
    },
    isBtnDisabled(data) {
      let isDisabled = false;

      if (data.viewStatus === 2) {
        isDisabled = true;
      }

      return isDisabled;
    },
    /**
     * 是否为单构件类型的构件
     */
    isEntityElem(elemInfo) {
      let allDataSets = this.findAllNodeByLevel(this.sceneData, 2);
      let allEntityElems = allDataSets.filter((el) =>
        elemDataSetType.includes(el.srcDataSetType)
      );

      let find = allEntityElems.find((item) => {
        let dataSetId = item.srcDataSetId;
        dataSetId = dataSetId.replaceAll("-", "");
        return elemInfo.dataSetId === dataSetId;
      });

      return find;
    },
    formatTransInfo(transInfo) {
      transInfo.forEach((item) => {
        let rotate = item.rotate.split(" ");
        item.rotate = rotate.map((el) => Number(el));
        let scale = item.scale.split(" ");
        item.scale = scale.map((el) => Number(el));
        let translation = item.translation.split(" ");
        item.translation = translation.map((el) => Number(el));
      });
      return transInfo;
    },
    resetSceneData() {
      let sceneData = this.sceneData;
      let rootFolders = this.findAllNodeByLevel(sceneData, 3);
      rootFolders.forEach((item) => {
        this.$set(item, "disabled", false);
      });

      let allDatasets = this.findAllNodeByLevel(sceneData, 2);
      allDatasets.forEach((item) => {
        this.$set(item, "disabled", false);
      });

      let allFolders = this.findAllNodeByLevel(sceneData, 1);
      allFolders.forEach((item) => {
        this.$set(item, "disabled", false);
      });
    },
    formatSceneData(sceneData) {
      let dataSetType = this.posEditInfo.dataSetType;
      let rootFolders = this.findAllNodeByLevel(sceneData, 3);
      rootFolders.forEach((item) => {
        if (item.dataSetType !== dataSetType) {
          this.$set(item, "disabled", true);
        }
      });

      let allDatasets = this.findAllNodeByLevel(sceneData, 2);
      allDatasets.forEach((item) => {
        if (item.dataSetType !== dataSetType) {
          this.$set(item, "disabled", true);
        }
        if (item.viewStatus === 2) {
          this.$set(item, "disabled", true);
        }
      });

      let allFolders = this.findAllNodeByLevel(sceneData, 1);
      allFolders.forEach((item) => {
        let leafChildNodes = this.findAllNodeByLevel(item.subNodes, 2);
        if (leafChildNodes.length) {
          let isDisabled = leafChildNodes.every((el) => el.disabled);
          if (isDisabled) {
            this.$set(item, "disabled", true);
          }
        }
      });
    },
    findAllNodeByLevel(data, level) {
      const array = [];

      const traverse = (item) => {
        if (item.nodeType === level) {
          array.push(item);
        }
        if (item.subNodes && item.subNodes.length) {
          item.subNodes.forEach((subNode) => {
            traverse(subNode);
          });
        }
      };

      data.forEach((item) => {
        traverse(item);
      });

      return array;
    },
    findAllChildNodes(data) {
      let childNodes = [];
      let rootFolders = this.findAllNodeByLevel(data, 3);
      let allFolders = this.findAllNodeByLevel(data, 1);
      let allDatasets = this.findAllNodeByLevel(data, 2);

      childNodes = [...rootFolders, ...allFolders, ...allDatasets];
      return childNodes;
    },
    findAllParentNodes(nodeObject) {
      const parentNodes = [];

      const traverse = (item) => {
        let nodeData = item.data;
        if (nodeData.nodeType) {
          parentNodes.push(nodeData);
        }
        if (item.parent) {
          traverse(item.parent);
        }
      };

      traverse(nodeObject);

      return parentNodes;
    },
    getAllFormatedDataSets(nodeData) {
      let dataSets = [];
      let allDataSets = this.findAllNodeByLevel([nodeData], 2);
      allDataSets.forEach((item) => {
        if (elemDataSetType.includes(item.dataSetType)) {
          let dataSetId = item.srcDataSetId.replaceAll("-", "");
          let find = dataSets.find((el) => el.dataSetId === dataSetId);
          if (find) {
            find.elemIdList.push(item.elemId);
          } else {
            let obj = {
              dataSetId,
              dataSetType: item.dataSetType,
              elemIdList: [item.elemId],
            };
            dataSets.push(obj);
          }
        } else {
          let dataSetId = item.dataSetId.replaceAll("-", "");
          let obj = {
            dataSetId,
            dataSetType: item.dataSetType,
            elemIdList: [],
          };
          dataSets.push(obj);
        }
      });
      return dataSets;
    },
    getTreeNodeClassName(nodeInfo) {
      let className = "custom-node-box";
      if (nodeInfo.disabled || nodeInfo.viewStatus === 2) {
        className += " node-disabled";
      }

      return className;
    },
    getIcon(nodeInfo) {
      let nodeType = nodeInfo.nodeType;
      if (nodeType === 1) return "ic-ico_folder";

      let srcDataSetType = nodeInfo.srcDataSetType;
      switch (srcDataSetType) {
        case 0:
          return "ic-moxing";
        case 13:
          return "ic-yg";
        case 10:
          return "ic-WMTS";
        case 11:
          return "ic-qxsy";
        case 15:
          return "ic-dy";
        case 16:
          return "ic-CADwapian";
        case 17:
          return "ic-yuanjian";
        case 18:
          return "ic-yuanjian";
        case 19:
          return "ic-yuanjian";
        case 20:
          return "ic-shiliangwapian-2";
        case 23:
          return "ic-shuimian";
        case 24:
          return "ic-kaiwa";
      }
    },
    setCheckedKeys() {
      let domRef = this.$refs.scenePosEditDataTree;
      let selectedDataSets = this.posEditInfo.selectedDataSets;
      let checkedKeys = selectedDataSets.map((item) => item.nodeId);
      domRef.setCheckedKeys(checkedKeys);
    },
    setExpandNodes() {
      let expandedNodeKeys = this.getExpandNodeKeys();
      let domRef = this.$refs.scenePosEditDataTree;
      let expandNodeKeys = this.posEditInfo.expandNodeKeys;

      expandedNodeKeys.forEach((item) => {
        let find = expandNodeKeys.find((el) => el === item);
        if (!find) {
          let node = domRef.getNode(item);
          node.expanded = false;
        }
      });

      expandNodeKeys.forEach((item) => {
        let node = domRef.getNode(item);
        node.expanded = true;
      });
    },
    getExpandNodeKeys() {
      let domRef = this.$refs.scenePosEditDataTree;
      let nodesMap = domRef.store.nodesMap;

      let expandNodeKeys = [];
      for (let key in nodesMap) {
        let expand = nodesMap[key].expanded;
        if (expand) {
          expandNodeKeys.push(key);
        }
      }

      return expandNodeKeys;
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
.scene-pos-edit-container {
  position: relative;
  width: 320px;
  height: 100%;
  padding: 15px;
  background: var(--side-bg-color);

  .common-tree-box {
    height: 100%;

    /deep/ .el-tree-node {
      position: relative;

      .el-tree-node__content {
        margin-top: 2px;
        margin-left: 20px;

        .el-checkbox {
          position: absolute;
          left: 0px;
          border: 1px solid transparent;
        }
      }
    }

    .custom-node-box {
      display: flex;
      justify-content: space-between;
      flex-grow: 1;
      overflow: hidden;

      .nodel-label-box {
        display: flex;
        align-items: center;
        overflow: hidden;

        .label-box {
          margin-left: 5px;
          font-size: 14px;
          font-weight: 400;
        }
      }

      .custom-button-box {
        padding: 0px 10px;

        .el-button {
          margin-right: 0px;
          padding: 0px;
        }

        .icon {
          font-size: 14px;
          color: var(--default-color);
        }
      }
    }

    .node-disabled {
      opacity: 0.5;
    }
  }
}
</style>